/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { get, set, action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
// Ember Imports
// Internal Imports
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import { byKeys, findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class PermissionReplyUpdates extends Component {
  permissionReplies = null;
  @tracked dialogOpen = false;
  @tracked filters = [];
  @tracked sortField = 'person.fullName';
  @tracked sortDir = 'asc';

  @computed(
    'permissionReplies.[]',
    'filters.@each.{field,value}',
    'sortDir',
    'sortField',
  )
  get sortedFilteredPermissionReplies() {
    let filteredPermissionReplies = this.permissionReplies.filter(Boolean);
    if (!isEmpty(this.filters)) {
      // Determine datatypes for any specified filters.
      let filters = this.filters.map((filter) => {
        return {
          key: filter.field,
          dataType: DataType.STRING,
          value: filter.value,
        };
      });

      // Apply all filters to each row in one hit, to avoid iterating over a
      // (potentially) large dataset multiple times.
      filteredPermissionReplies = filteredPermissionReplies.filter((row) => {
        return filters.every((filter) => {
          // Generic filter processing.
          return filterValue(
            get(row, filter.key) ?? '',
            filter.dataType,
            filter.value,
          );
        });
      });
    }

    let sortedFilteredPermissionReplies = filteredPermissionReplies.sort(
      byKeys(this.sortField),
    );
    if (this.sortDir === 'desc') {
      return sortedFilteredPermissionReplies.reverse();
    }
    return sortedFilteredPermissionReplies;
  }

  @action
  openDialog() {
    this.filters = [];
    this.dialogOpen = true;
    this.sortField = 'person.fullName';
    this.sortDir = 'asc';
  }

  @action
  filter(field, value) {
    let filter = findBy(this.filters, 'field', field);
    if (isEmpty(filter)) {
      // No existing filter on this field; add it.
      this.filters = [...this.filters, { field, value }];
      return;
    }

    if (isEmpty(value)) {
      // Filter has been cleared; remove it.
      this.filters = this.filters.filter((f) => f !== filter);
    } else {
      // Existing filter has been changed; update it.
      set(filter, 'value', value);
    }
  }
}
